import styled from "styled-components"

import {Body} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import {minWidthMedia} from "@irati/ui/src/global/media"
import Button from "@irati/ui/src/Button"

export const BalanceRow = styled.div`
  padding-top: 40px;
  display: flex;
  justify-content: space-between;
`

export const TopCard = styled(Card)`
  box-shadow: none;
  text-align: center;
  padding-top: 0;
  padding-bottom: 10px;
  margin-top: -20px;
`

export const GreyCard = styled(Card)`
  background-color: ${({theme}) => theme.colors.greys.light};
  box-shadow: none;
  border-radius: 0 0 3px 3px;
`

export const InnerCard = styled(Card)`
  box-shadow: none;
  border-radius: 0px;
`

export const StyledButton = styled(Button)`
  margin-top: 30px;
  width: 100%;
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  transform: translate(0, -30%);
  ${minWidthMedia.tablet`
    margin-bottom: 0;
  `}
`

export const Image = styled.img`
  border-radius: 50%;
  box-shadow:
    0 0 3px 0 rgba(61, 61, 54, 0.2),
    0 3px 2px 2px rgba(61, 61, 54, 0.15);
  background-color: ${({theme}) => theme.colors.greys.white};
  width: 80px;
  height: 80px;
  max-width: none;
  ${minWidthMedia.tablet`
    width: 120px;
    height: 120px;
  `}
`

interface RowWrapperProps {
  isFirst?: boolean
}

export const Wrapper = styled.div<RowWrapperProps>`
  display: block;
  padding: 10px 0;
  border-bottom: 1px solid ${({theme}) => theme.colors.greys.light};
  ${({isFirst, theme}) => (isFirst ? `border-top: 1px solid ${theme.colors.greys.light};` : "")};
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
`

export const StyledBody = styled(Body)`
  display: flex;
  align-content: center;
  margin: 5px 0;
  > svg {
    margin: 0 10px;
  }
`
